module.exports = __webpack_public_path__ + "img/img2.6a3f815b.png";